export enum OutboundShipmentSource {
  Api = "api",
  Checkout = "checkout",
  ConsolidationCarton = "consolidation-carton",
  FulfillmentGroups = "fulfillment-groups",
  LabelPrebuy = "label-prebuy",
  OmsReturnLabel = "oms-return-label",
  RateCalculator = "rate-calculator",
}
